import { Checkbox, PageTabsContent } from "@tellescope/ui";
import { useTranslation } from "react-i18next";
import { PORTAL_SCHEMA_RESTRICTION_KEYS } from "./roleEditorConfig";
import { RoleEditor } from "./useEditRoleDialog";
import { useRoleEditorLabels } from "./useRoleEditorLabels";

export interface PortalSchemaTabContentProps {
  editor: RoleEditor;
}

export const PortalSchemaTabContent = ({ editor }: PortalSchemaTabContentProps) => {
  const { t } = useTranslation("settings");
  const labels = useRoleEditorLabels();
  const { draft, togglePortalSchemaRestriction } = editor;

  return (
    <PageTabsContent
      value="portal-schema"
      className="px-6 py-4 space-y-6 overflow-y-auto"
      style={{ maxHeight: "min(80vh, 900px)" }}
    >
      <div className="space-y-1">
        <h3 className="text-sm font-medium">{t("Portal Schema Restrictions")}</h3>
        <p className="text-xs text-muted-foreground">
          {t("Prevent users with this role from editing Portal content, theming, or snippets.")}
        </p>
      </div>

      <div className="space-y-3">
        {PORTAL_SCHEMA_RESTRICTION_KEYS.map((key) => (
          <label key={key} className="flex items-start gap-2 text-sm">
            <Checkbox
              checked={!!draft.portalSchemaRestrictions[key]}
              onCheckedChange={(checked) => togglePortalSchemaRestriction(key, checked === true)}
              className="mt-0.5"
            />
            <span>{labels.portalSchemaRestrictions[key]}</span>
          </label>
        ))}
      </div>
    </PageTabsContent>
  );
};
